<script setup>
// Affichage de la file `useToast`. Monté une seule fois dans AdminLayout : ne rend
// rien tant qu'aucune notification n'est poussée.
// z-index au-dessus de BaseModal (z-[9999]) : beaucoup d'erreurs sont poussées
// depuis l'intérieur d'une modale, un toast masqué ne servirait à rien.
import { useToast } from '../../composables/useToast';
import { AlertTriangle, CheckCircle2, Info, X } from 'lucide-vue-next';

const { toasts, dismiss } = useToast();

const STYLE = {
  error: 'bg-red-50 border-red-200 text-red-800',
  success: 'bg-emerald-50 border-emerald-200 text-emerald-800',
  info: 'bg-white border-gray-200 text-gray-800'
};
const ICON = { error: AlertTriangle, success: CheckCircle2, info: Info };
</script>

<template>
  <Teleport to="body">
    <div class="fixed z-[10050] inset-x-3 bottom-3 sm:inset-x-auto sm:right-4 sm:bottom-4 sm:w-[380px] flex flex-col gap-2 pointer-events-none">
      <TransitionGroup name="toast">
        <div v-for="t in toasts" :key="t.id"
             :class="['pointer-events-auto rounded-xl border shadow-lg px-3 py-2.5 flex items-start gap-2 text-xs leading-snug', STYLE[t.type] || STYLE.info]"
             role="status" aria-live="polite">
          <component :is="ICON[t.type] || Info" class="w-4 h-4 shrink-0 mt-0.5" />
          <span class="flex-1 min-w-0 break-words">{{ t.text }}</span>
          <button type="button" @click="dismiss(t.id)" aria-label="Fermer"
                  class="shrink-0 opacity-50 hover:opacity-100 transition-opacity p-0.5 -m-0.5">
            <X class="w-3.5 h-3.5" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active, .toast-leave-active { transition: opacity 180ms ease, transform 180ms ease; }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(8px); }
.toast-move { transition: transform 180ms ease; }
</style>
